import { useEffect, useState, useRef } from "react"
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";

const db = require("mime-db");

const Chat = ({numId}) => {
    const [text, setText] = useState("");
    const [messages, setMessages] = useState({pages: 0, results: []});
    const [loading, setLoading] = useState(false);
    const [sendingText, setSendingText] = useState(false);
    const [showTextBox, setShowTextBox] = useState(false);
    const [page, setPage] = useState(1);
    const { auth } = useAuth();
    const axiosPrivate = useAxiosPrivate();
    const chatRef = useRef();

    useEffect(() => {
        const element = chatRef.current;
        if (element) {
            element.scrollTop = element.scrollHeight;
        }
    }, []);

    useEffect(() => {
        const fetch = async () => {
            try {
                setLoading(true);
                const response = await axiosPrivate.get(`/messages/${numId}?page=${page}&per_page=100&order=desc`, {headers: {Authorization: "Bearer " + auth.accessToken}});
                const results = response.data.results;
                const reversed = results.reverse();
                setMessages(curr => ({pages: response.data.pages, results: [...reversed, ...curr.results]}));
            } catch(err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate, numId, page]);

    const send = async () => {
        try {
            setSendingText(true);
            await axiosPrivate.post(`/send_msg/${numId}`, {text}, {headers: {Authorization: "Bearer " + auth.accessToken}});
            setText("");
        } catch (err) {
            console.log(err);
        } finally {
            setSendingText(false);
        }
    }

    return (
        <>
            <div style={{width: "53%"}}>
                <div style={{overflowY: "auto", height: "65vh"}} ref={chatRef} className="bg-slate-100 rounded-lg">
                    <div>
                        <div className="min-h-full w-full p-4 bg-slate-100 sm:p-6 md:p-8 rounded-lg" >
                            <div>
                                {loading ? <div>Loading...</div> : null}
                                <div className="bg-indigo-500 p-2 rounded-lg flex" style={{position:'absolute', top: '18rem', columnGap:'10px'}}>
                                    {messages.pages > page ? (
                                        <button className="text-xs" style={{color:"#fff"}} onClick={() => setPage(curr => curr + 1)}>
                                            Load More
                                        </button>
                                    ) : null}
                                </div>
                                {messages.results.map(message => (
                                    <div key={message.id}>
                                        {message.msg_type === "FLOW" ? <FlowMessage message={message}/> : <TextMessage message={message}/>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showTextBox ? (
                <div style={{width: "24%"}}>
                    <div>
                        <button onClick={() => setShowTextBox(false)} className="text-sm">Hide textbox</button>
                    </div>
                    <label htmlFor="custom_msg" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                        <input
                            type="text"
                            name="custom_msg"
                            placeholder="message"
                            onChange={(e) => setText(e.target.value)}
                            value={text}
                            className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            style={{padding: "0.5rem", width: "100%"}}
                        />
                        <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                            Message
                        </span>
                    </label>
                    {text && (
                        sendingText ? (
                            <button style={{color: "#fff"}} className="bg-indigo-400 py-0.5 px-1 rounded-lg text-xs">
                                Sending...
                            </button>
                        ) : (
                            <button style={{color: "#fff"}} className="bg-indigo-400 py-0.5 px-1 rounded-lg text-xs" onClick={() => send()}>
                                Send
                            </button>
                        )
                    )}
                </div>
            ) : (
                <div>
                    <button onClick={() => setShowTextBox(true)} className="text-sm">Show textbox</button>
                </div>
            )}
        </>
    )
}

const FlowMessage = ({message}) => {
    const [showReplies, setShowReplies] = useState(false);

    return (
        <div>
            {showReplies ? <Replies showReplies={showReplies} message={message} setShowReplies={setShowReplies}/> : null}
            <div className="bg-white rounded-lg w-2/3 p-3 pb-2 mb-4 grid gap-y-3">
                <div>
                    <p className="text-gray-700">
                            {message.data.interactive.header.text}
                            {message.data.interactive.body.text}
                            {message.data.interactive?.footer?.text}<br />
                            <span className="text-xs">{message.created_at}</span>
                    </p>
                </div>
                <div>
                    <button className="cursor-pointer text-xs" onClick={() => setShowReplies(true)}>View Replies</button>
                </div>
            </div>
        </div>
    )
}

const Replies = ({message, setShowReplies, showReplies}) => {
    const [screen, setScreen] = useState("");
    const [replies, setReplies] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const changeScreen = (evt) => {
        setScreen(evt.target.value);
        const screenReplies = message.replies.filter(reply => reply.screen === evt.target.value);
        setReplies(screenReplies.reverse());
    }

    const download = async (file) => {
        try {
            const response = await axiosPrivate.post("/download", file, {headers: {Authorization: "Bearer " + auth.accessToken}, responseType: "blob"});
            const ext = db[response.headers["content-type"]].extensions[0];
            const href = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", `file.${ext}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch(err) {
            console.log(err);
        }
    }

    const Reply = ({field, reply}) => {
        if (Array.isArray(reply)) {
            return (
                <div>
                    {field}: <button style={{color:'#fff'}} className="bg-indigo-400 py-0.5 px-1 rounded-lg text-xs" onClick={() => download(reply[0])}>Download</button>
                </div>
            )
        }
        return <div>{field}: {reply}</div>
    }

    const closeModal = () => {
        setShowReplies(false);
    }

    return (
        <div>
            <div 
                id="popup-modal" 
                tabIndex="-1" 
                className={showReplies ? "overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full":
                    "hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"}
                style={{background:'linear-gradient(45deg, gray, transparent)'}}
            >
                <div className="relative p-4 w-full max-w-md max-h-full" style={{left: '40%', top: '25%'}}>
                    <div className="p-6 bg-white rounded-lg grid gap-y-4">
                        < div className="flex justify-between">
                            <select value={screen} onChange={changeScreen} className="text-sm">
                                <option value=""></option>
                                {message.screens.map((screen, idx) => (
                                    <option className="p-0.5" key={idx} value={screen}>{screen}</option>
                                ))}
                            </select>
                            <button onClick={closeModal} type="button" className="text-black text-sm" data-modal-hide="popup-modal">
                                Close
                            </button>
                        </div>
                        {replies.map((reply, idx) => (
                            <div key={idx}>
                                <div style={{padding:'0.5rem 0'}}>Message</div>
                                <div className="bg-slate-100 p-4 rounded-lg">
                                    <div className="pb-2">Reply</div>
                                    <div className="request text-sm">
                                        {Object.keys(reply.request_data).map((name, idx) => {
                                            return <Reply key={idx} field={name} reply={reply.request_data[name]}/>
                                        })}
                                    </div>
                                    {reply.response_data &&
                                        <>
                                            <div className="pt-2 pb-2">Response</div>
                                            {reply.response_data && (
                                                <div className="response">
                                                    {Object.keys(reply.response_data).map((name, idx) => {
                                                        return <Reply key={idx} field={name} reply={reply.response_data[name]}/>
                                                    })}
                                                </div>
                                            )}
                                        </>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    )
}

const TextMessage = ({message}) => {
    return (
        <>
            {message.inbound ? (
                <div className="flex justify-end mb-4 cursor-pointer">
                    <div className="flex max-w-96 bg-indigo-500 text-white rounded-lg p-3 gap-3">
                    <p className="text-white-700">
                        {message.data}<br />
                        <span className="text-xs">{message.created_at}</span>
                        </p>
                    </div>
                </div>
            ) : (
                <div className="flex mb-4 cursor-pointer">
                    <div className="flex max-w-96 bg-slate-100 rounded-lg p-3 gap-3">
                        <p className="text-white-700">
                            {message.data}<br />
                            <span className="text-xs">{message.created_at}</span>
                        </p>
                    </div>
                </div>
            )}
        </>
    )
}

export default Chat;
